import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "components-editor" }
const _hoisted_2 = {
  key: 0,
  class: "component-warning",
  role: "status"
}
const _hoisted_3 = { class: "component-heading" }
const _hoisted_4 = { class: "enabled-toggle" }
const _hoisted_5 = ["checked", "onChange"]
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["value", "onInput"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { class: "add-component" }
const _hoisted_11 = ["value"]
const _hoisted_12 = ["disabled"]

import StudioSelectField from "../../../StudioSelectField.vue";
import { computed, ref, watch } from "vue";
import {
  createClipComponent,
  getClipComponentTemplates,
  resolveClipComponentTemplate,
} from "../../config/clipComponentRegistry";
import { getLineDefinition } from "../../config/lineRegistry";
import ClipPropertyEditor from "./ClipPropertyEditor.vue";
import type {
  ClipComponent,
  PerformanceClip,
} from "../../types/DialogueNode";


export default /*@__PURE__*/_defineComponent({
  __name: 'ClipComponentsEditor',
  props: {
    clip: {}
  },
  setup(__props: any) {

const props = __props;
const cameraParameterCount = computed(() =>
  props.clip.components.filter(component => component.templateId === "camera.shot").length,
);
const lineDefinition = computed(() => getLineDefinition(props.clip.type));
const availableTemplates = computed(() => {
  const allowed = lineDefinition.value?.allowedComponentTemplateIds;
  return getClipComponentTemplates(allowed?.length ? allowed : undefined).filter(
    (template) => !template.id.startsWith("base.") &&
      (template.id !== "camera.shot" || cameraParameterCount.value === 0),
  );
});
const selectedTemplateId = ref("");

watch(
  availableTemplates,
  (templates) => {
    if (!templates.some((template) => template.id === selectedTemplateId.value)) {
      selectedTemplateId.value = templates[0]?.id ?? "";
    }
  },
  { immediate: true },
);

function addComponent() {
  if (availableTemplates.value.some(template => template.id === selectedTemplateId.value)) {
    props.clip.components = [...props.clip.components, createClipComponent(selectedTemplateId.value)];
  }
}

function deleteComponent(component: ClipComponent) {
  props.clip.components = props.clip.components.filter((item) => item.id !== component.id);
}

function updateComponent(component: ClipComponent, update: Partial<ClipComponent>) {
  props.clip.components = props.clip.components.map((item) =>
    item.id === component.id ? { ...item, ...update } : item,
  );
}

function updateProperty(component: ClipComponent, key: string, value: unknown) {
  updateComponent(component, { properties: { ...component.properties, [key]: value } });
}

function updateEnabled(component: ClipComponent, event: Event) {
  updateComponent(component, { enabled: (event.target as HTMLInputElement).checked });
}

function addCustomProperty(component: ClipComponent) {
  const key = prompt("输入属性键名", "");
  if (!key?.trim()) return;
  if (Object.prototype.hasOwnProperty.call(component.properties, key)) return;
  updateProperty(component, key, "");
}

function deleteCustomProperty(component: ClipComponent, key: string) {
  const properties = { ...component.properties };
  delete properties[key];
  updateComponent(component, { properties });
}

function resolvedProperties(component: ClipComponent) {
  return resolveClipComponentTemplate(component.templateId)?.properties ?? [];
}

function customProperties(component: ClipComponent) {
  const known = new Set(resolvedProperties(component).map((item) => item.key));
  return Object.keys(component.properties).filter((key) => !known.has(key));
}

function updateString(component: ClipComponent, key: string, event: Event) {
  updateProperty(component, key, (event.target as HTMLInputElement).value);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("header", null, [
      _cache[1] || (_cache[1] = _createElementVNode("strong", null, "Components", -1)),
      _createElementVNode("span", null, _toDisplayString(__props.clip.components.length), 1)
    ]),
    (cameraParameterCount.value > 1)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, " 当前有 " + _toDisplayString(cameraParameterCount.value) + " 份镜头参数，请保留需要的一份并删除其余项。多个启用项的同名参数会由后面的覆盖。 ", 1))
      : _createCommentVNode("", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.clip.components, (component) => {
      return (_openBlock(), _createElementBlock("article", {
        key: component.id,
        class: "component-card"
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, [
            _createElementVNode("input", {
              checked: component.enabled,
              type: "checkbox",
              onChange: ($event: any) => (updateEnabled(component, $event))
            }, null, 40, _hoisted_5),
            _createElementVNode("span", null, _toDisplayString(component.name), 1)
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: ($event: any) => (deleteComponent(component))
          }, "删除", 8, _hoisted_6)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(resolvedProperties(component).filter(property => component.templateId !== 'camera.shot' || property.key !== 'cameraName'), (property) => {
          return (_openBlock(), _createBlock(ClipPropertyEditor, {
            key: property.key,
            property: property,
            "model-value": component.properties[property.key],
            "sibling-values": component.properties,
            "onUpdate:modelValue": ($event: any) => (updateProperty(component, property.key, $event))
          }, null, 8, ["property", "model-value", "sibling-values", "onUpdate:modelValue"]))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(customProperties(component), (key) => {
          return (_openBlock(), _createElementBlock("label", {
            key: key,
            class: "custom-field"
          }, [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(key) + " ", 1),
              _cache[2] || (_cache[2] = _createElementVNode("em", null, "自定义", -1))
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("input", {
                value: String(component.properties[key] ?? ''),
                onInput: ($event: any) => (updateString(component, key, $event))
              }, null, 40, _hoisted_7),
              _createElementVNode("button", {
                type: "button",
                onClick: ($event: any) => (deleteCustomProperty(component, key))
              }, "×", 8, _hoisted_8)
            ])
          ]))
        }), 128)),
        _createElementVNode("button", {
          type: "button",
          class: "add-property",
          onClick: ($event: any) => (addCustomProperty(component))
        }, " ＋ 自定义属性 ", 8, _hoisted_9)
      ]))
    }), 128)),
    _createElementVNode("div", _hoisted_10, [
      _createVNode(StudioSelectField, {
        modelValue: selectedTemplateId.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((selectedTemplateId).value = $event)),
        "aria-label": "添加组件类型",
        disabled: !availableTemplates.value.length
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableTemplates.value, (template) => {
            return (_openBlock(), _createElementBlock("option", {
              key: template.id,
              value: template.id
            }, _toDisplayString(template.name), 9, _hoisted_11))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "disabled"]),
      _createElementVNode("button", {
        type: "button",
        disabled: !selectedTemplateId.value,
        onClick: addComponent
      }, "＋ 添加", 8, _hoisted_12)
    ])
  ]))
}
}

})